import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false,
})
export class CustomBreadcrumbComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  enabled$: Observable<boolean> = of(false);

  constructor() {
    this.detectRouteChanges();
  }

  private detectRouteChanges(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.enabled$ = this.getActivatedRoute(this.route).data.pipe(
          map((data: any) =>
            'disableBreadcrumb' in data ? !data.disableBreadcrumb : true,
          ),
        );
      });
  }

  private getActivatedRoute(activatedRoute: ActivatedRoute): ActivatedRoute {
    return activatedRoute.firstChild
      ? this.getActivatedRoute(activatedRoute.firstChild)
      : activatedRoute;
  }
}
